import { IDBPDatabase } from 'idb'

import asyncForEach from 'utils/asyncForEach'

import { IDBSchema } from '../types'

/**
 * CHANGES:
 *
 * - Removed `tabOrder` from `projects` table
 * - Added a `createdAt` & `updatedAt` field for each table
 * - Added an index for `createdAt` for each table
 * - Added an index for `updatedAt` for each table
 */

export default (
  database: IDBPDatabase<IDBSchema>,
  transaction: IDBTransaction,
  next: () => void
) => {
  STUDIO_ENV_DEVELOPMENT && console.log('---Running migration for v11---')

  const projectStore = transaction.objectStore('projects')
  projectStore.createIndex('createdAt', 'createdAt')
  projectStore.createIndex('updatedAt', 'updatedAt')

  const actionStore = transaction.objectStore('actions')
  actionStore.createIndex('createdAt', 'createdAt')
  actionStore.createIndex('updatedAt', 'updatedAt')

  const scriptStore = transaction.objectStore('scripts')
  scriptStore.createIndex('createdAt', 'createdAt')
  scriptStore.createIndex('updatedAt', 'updatedAt')

  const sessionStore = transaction.objectStore('sessions')
  sessionStore.createIndex('createdAt', 'createdAt')
  sessionStore.createIndex('updatedAt', 'updatedAt')

  const tabStore = transaction.objectStore('tabs')
  tabStore.createIndex('createdAt', 'createdAt')
  tabStore.createIndex('updatedAt', 'updatedAt')

  // First, we get all projects
  const projectsRequest = projectStore.getAll()
  projectsRequest.onsuccess = () => {
    const projects = projectsRequest.result
    STUDIO_ENV_DEVELOPMENT && console.log('Found all projects', projects)

    // Then, for each project, make mofifications
    asyncForEach(
      projects,
      (project, next) => {
        STUDIO_ENV_DEVELOPMENT && console.log('Updating project', project)
        delete project.tabOrder // Remove tabOrder
        project.createdAt = new Date().toISOString() // Add createdAt
        project.updatedAt = new Date().toISOString() // Add updatedAt
        projectStore.put(project).onsuccess = next
      },
      () => {
        // For all other stores, make modifications
        asyncForEach(
          [actionStore, scriptStore, sessionStore, tabStore],
          (store, next) => {
            const getAllRequest = store.getAll()
            getAllRequest.onsuccess = () => {
              const items = getAllRequest.result
              asyncForEach(
                items,
                (item, next) => {
                  item.createdAt = new Date().toISOString() // Add createdAt
                  item.updatedAt = new Date().toISOString() // Add updatedAt
                  store.put(item).onsuccess = next
                },
                () => next()
              )
            }
          },
          () => {
            STUDIO_ENV_DEVELOPMENT && console.log('---Migrated to v11---')
            return next()
          }
        )
      }
    )
  }

  return next()
}
